var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"scroll":function($event){return _vm.handleScroll()}}},[_c('main',{staticClass:"content-main"},[(
        ['Login', 'Polity', 'Terms', 'DeleteAccount', 'DeleteAccountSalonDate'].indexOf(_vm.$route.name) ===
        -1
      )?_c('Menu'):_vm._e(),_c('div',{staticClass:"content-main--div",class:{
        'content-main--div--login':
          ['Login', 'Polity', 'Terms', 'DeleteAccount', 'DeleteAccountSalonDate'].indexOf(_vm.$route.name) >
          -1,
      }},[(
          ['Login', 'Polity', 'Terms', 'DeleteAccount', 'DeleteAccountSalonDate'].indexOf(
            _vm.$route.name
          ) === -1
        )?_c('Header',{attrs:{"isScrolled":_vm.isScrolled,"isScrolledMobile":_vm.isScrolledMobile}}):_vm._e(),_c('router-view')],1)],1),_c('Loading'),_c('div',{staticClass:"backdrop_bar d-none"}),_c('ModalCategory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }